// services/admin/adminRegime.service.ts
// Conferência e aprovação do regime tarifário por destino.
//
// As rotas /api/admin/regimes existiam desde a apuração por IA e nunca tiveram
// tela: aprovar ou rejeitar um regime só era possível por Postman. Este service
// é a ponte que faltava.
import { ADMIN_API } from "./adminApi";

export type RegimeStatus = "pendente" | "aprovado" | "rejeitado";

export type RegimeMedida = {
  tipo?: string;
  descricao?: string;
  aliquota_pct?: number;
  [k: string]: unknown;
};

export type RegimeFonte = { titulo?: string; url?: string; [k: string]: unknown };

export type AdminRegime = {
  id: number;
  pais_destino: string;
  status: RegimeStatus;
  confianca: "alta" | "media" | "baixa" | null;
  resumo: string | null;
  medidas: RegimeMedida[] | null;
  de_minimis: unknown;
  imposto_consumo: unknown;
  sobretaxa_total_pct: number | null;
  divergencias: string[] | null;
  rodadas: unknown;
  medidas_descartadas: unknown[];
  fontes: RegimeFonte[] | null;
  valido_ate: string | null;
  vencido: boolean | null;
  aprovado_por: string | null;
  aprovado_em: string | null;
  created_at: string;
};

export type RegimesResposta = {
  ok: true;
  validade_dias: number;
  regimes: AdminRegime[];
};

export const listAdminRegimes = async (filtros: { pais?: string; status?: string } = {}) => {
  const params = Object.fromEntries(
    Object.entries(filtros).filter(([, v]) => v !== "" && v !== undefined && v !== null)
  );
  const { data } = await ADMIN_API.get<RegimesResposta>("/api/admin/regimes", { params });
  return data;
};

export const getAdminRegime = async (id: string | number) => {
  const { data } = await ADMIN_API.get<{ ok: true; regime: AdminRegime }>(
    `/api/admin/regimes/${id}`
  );
  return data.regime;
};

/** Dispara a apuração. O backend responde 202 e segue em background. */
export const pesquisarRegime = async (pais: string) => {
  const { data } = await ADMIN_API.post<{ ok: true; pais: string; aviso: string }>(
    "/api/admin/regimes/pesquisar",
    { pais: pais.trim().toUpperCase() }
  );
  return data;
};

/**
 * Aprova. Quando as duas rodadas divergiram, o backend devolve 409 pedindo
 * confirmação — `cienteDaDivergencia` é o reenvio deliberado.
 */
export const aprovarRegime = async (id: string | number, cienteDaDivergencia = false) => {
  const { data } = await ADMIN_API.post<{
    ok: true;
    id: number;
    status: string;
    aprovado_por: string;
  }>(`/api/admin/regimes/${id}/aprovar`, { ciente_da_divergencia: cienteDaDivergencia });
  return data;
};

export const rejeitarRegime = async (id: string | number, motivo?: string) => {
  const { data } = await ADMIN_API.post<{ ok: true; id: number; status: string }>(
    `/api/admin/regimes/${id}/rejeitar`,
    { motivo: motivo || null }
  );
  return data;
};
